import { Host, h } from '@stencil/core';
export class AibaModal {
  constructor() {
    this.modalPosition = undefined;
    this.closeButtonData = undefined;
    this.styles = undefined;
    this.modalOpen = true;
    this.classes = undefined;
    this.handleClick = undefined;
    this.firstTime = true;
    this.handlers = undefined;
    this.bodyRef = undefined;
  }
  componentWillLoad() {
    this.bodyRef = document.querySelector('body');
    this.bodyRef.style.overflow = 'hidden';
  }
  componentDidLoad() {
    let classList;
    if (this.modalParentWrapperRef) {
      classList = Array.from(this.modalParentWrapperRef.classList);
    }
    if (classList.includes('modal-hidden')) {
      this.bodyRef = document.querySelector('body');
      this.bodyRef.style.overflow = 'auto';
    }
  }
  componentDidRender() {
    if (this.firstTime === true) {
      this.modalWrapperRef.querySelector('.modal_close-btn').focus();
      this.firstTime = false;
    }
  }
  modalHandleClick(e) {
    var _a, _b;
    document.querySelector('body').style.overflow = 'auto';
    this.modalOpen = false;
    this.closemodal.emit(true);
    this.handleClick && this.handleClick(e);
    (this === null || this === void 0 ? void 0 : this.handlers) && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.modalHandleClick) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.modalHandleClick(e));
  }
  /* istanbul ignore next */
  trapKeyboardFocus(e) {
    if (e.key === 'Tab') {
      //We re-select on every tab press so we can adapt to any added/removed focusable elements
      // tslint:disable-next-line: max-line-length
      const windowRef = window.document.body.querySelector('aiba-app').shadowRoot;
      const focusEls = this.modalWrapperRef.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]');
      const firstFocusEl = focusEls[0];
      const lastFocusEl = focusEls[focusEls.length - 1];
      if (e.shiftKey) {
        //shift + tab
        if (windowRef.activeElement === firstFocusEl) {
          lastFocusEl.focus();
          e.preventDefault();
        }
      }
      else {
        //Tab
        console.log(windowRef.activeElement, lastFocusEl);
        if (windowRef.activeElement === lastFocusEl) {
          firstFocusEl.focus();
          e.preventDefault();
        }
      }
    }
    if (e.key === 'Escape') {
      this.modalHandleClick(e);
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return (h(Host, null, this.styles && h("styles", null, this.styles), h("div", { class: 'modal-block', ref: el => (this.modalParentWrapperRef = el) }, h("div", { class: `modal ${this.modalPosition} ${this.modalOpen ? 'show' : 'hide'}`, onKeyDown: event => this.trapKeyboardFocus(event), ref: el => (this.modalWrapperRef = el) }, h("aiba-button", Object.assign({}, this.closeButtonData, { variant: ((_a = this.closeButtonData) === null || _a === void 0 ? void 0 : _a.variant) ? this.closeButtonData.variant : '', textOnly: (_b = this.closeButtonData) === null || _b === void 0 ? void 0 : _b.textOnly, iconOnly: (_c = this.closeButtonData) === null || _c === void 0 ? void 0 : _c.iconOnly, iconWithText: ((_d = this.closeButtonData) === null || _d === void 0 ? void 0 : _d.iconWithText) ? this.closeButtonData.iconWithText : false, path: ((_e = this.closeButtonData) === null || _e === void 0 ? void 0 : _e.path) ? this.closeButtonData.path : '', pathWithHover: ((_f = this.closeButtonData) === null || _f === void 0 ? void 0 : _f.pathWithHover) ? this.closeButtonData.pathWithHover : '', arialabel: ((_g = this.closeButtonData) === null || _g === void 0 ? void 0 : _g.arialabel) ? this.closeButtonData.arialabel : '', value: ((_h = this.closeButtonData) === null || _h === void 0 ? void 0 : _h.value) ? this.closeButtonData.value : 'X', styles: ((_j = this.closeButtonData) === null || _j === void 0 ? void 0 : _j.styles) ? this.closeButtonData.styles : '', classes: ((_k = this.closeButtonData) === null || _k === void 0 ? void 0 : _k.classes) ? this.closeButtonData.classes : 'modal_close-btn', handleClick: e => {
        this.modalHandleClick(e);
      } })), h("slot", null)))));
  }
  static get is() { return "aiba-modal"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-modal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-modal.css"]
    };
  }
  static get properties() {
    return {
      "modalPosition": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "modal-position",
        "reflect": false
      },
      "closeButtonData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "close-button-data",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "modalOpen": {},
      "firstTime": {},
      "bodyRef": {}
    };
  }
  static get events() {
    return [{
        "method": "closemodal",
        "name": "closemodal",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        }
      }];
  }
}
/* IGNORED TEST CASES

- [trapKeyboardFocus] -> no. of Lines = 52-81
  REASON :(window.document is not working in test env + focus of element is not being able to tested properly)

*/
//# sourceMappingURL=aiba-modal.js.map
